import { match as matchBrandRoute } from "@faire/web-api--source/routes/www/brand/brandToken/match";

export const isBrandPageRoute = (pathname: string, search: string) => {
  if (!pathname.endsWith("/")) {
    pathname += "/";
  }
  return matchBrandRoute(`${pathname}${search}`);
};
